import { Component, Host, h, Prop, Element, State } from '@stencil/core';
import Helper from '../../Helpers/Helper';
@Component({
  tag: 'salla-products-slider',
  styleUrl: 'salla-products-slider.scss'
})

//todo:: extends this component from salla-products-list or the opposite
export class SallaProductsSlider {
  /**
   * Title of the block - works only if slider is true
   * @type {string}
   * @default ''
   * */
  @Prop() blockTitle: string;

  /**
   * Sub title of the block - works only if slider is true
   * @type {string}
   * @default ''
   * */
  @Prop() subTitle: string;

  /**
   * Slider Id, if not provided will be generated automatically
   * @type {string}
   * @default ''
   * */
  @Prop() sliderId: string;

  /**
   * Display 'ALL' URL
   * @type {string}
   * @default ''
   * */
  @Prop() displayAllUrl: string;

  /**
  * autoplay option for products slider
  */
  @Prop({ mutable: true }) autoplay: boolean

  /**
   * Source of the products, if api will get the products from the API, if json will get the products from the products prop
   * @type {string}
   * @default ''
   * */
  @Prop({
    reflect: true,
    mutable: true
  }) source: 'categories' | 'latest' | 'related' | 'brands' | 'json' | 'tags' | 'selected' | 'offers' | 'landing-page' | 'wishlist' | 'top-rated';

  /**
   * The source value, cloud be different values as following:
   * - array of ids when `source` in ['categories', 'brands', 'tags', 'selected']
   * - products payload when `source` = 'json'
   * - product_id when `source` = 'related'
   *
   * @type {string}
   * */
  @Prop() sourceValue: string;

  /**
   * Limit for number of products in the list.
   */
  @Prop({ mutable: true }) limit: number;

  /**
   * Slider Configs refer to https://swiperjs.com/swiper-api#parameters and pass the entire config object
   * @example
   * let productsSlider = document.querySelector('salla-products-slider');
   *  productsSlider.sliderConfig = {
   *  slidesPerView: 1,
   *  spaceBetween : 30,
   *  lazy: true,
   * }
   *
   */
  @Prop({ reflect: true }) sliderConfig: any;

  /**
   * Custom Card Component for the Salla Products Slider.
   *
   * This component allows you to customize the appearance of individual product cards within a Salla Products Slider.
   *
   * @example
   * <salla-products-slider product-card-component="my-custom-card-style1" ...
   * <salla-products-slider product-card-component="my-custom-card-style2" ...
   */
  @Prop() productCardComponent: string = 'custom-salla-product-card';

  /**
   * Specifies additional data to be included in the product fetch response.
   * The value can be an array of strings or a JSON string.
   * 
   * Example:
   * - As an array: includes=["options"]
   * - As a JSON string: includes='["options"]'
   * 
   * The array or JSON string can include:
   * - "options": Include product options in the response.
   * - "images": Include product images in the response.
   */
  @Prop({mutable: true}) includes: string[];


  @Element() host: HTMLElement;
  //todo:: support limit, default =10, make sure that maximum is 32,


  @State() productsData: any;
  @State() isReady: boolean;
  @State() sourceValueIsValid: boolean;
  @State() hasCustomComponent: boolean;
  @State() apiUrl: string = '';
  @State() parsedSourceValue: any;

  componentWillLoad() {
    return salla.onReady()
    .then(() => {
        //TODO:: check why `this.includes` not working!!
        this.includes = Helper.parseJson(this.includes||this.host.getAttribute('includes'));
        if (!Array.isArray(this.includes)) {
          this.includes = null;
        }
        Helper.setIncludes(this.includes);
      this.sourceValueIsValid = !!(this.getSourceValue() || this.isSourceWithoutValue());
      if (!this.sourceValueIsValid) {
        salla.logger.warn(`source-value prop is required for source [${this.getSource()
          }]`);
        return;
      }
      this.hasCustomComponent = !!customElements.get(this.productCardComponent);

      if (this.source === 'json') {
        this.productsData = this.getSourceValue();
        this.isReady = true
        return;
      }

      if ((this.getSource() == 'related' && !salla.config.get('store.settings.product.related_products_enabled'))) {
        this.isReady = false
        return;
      }

      return salla.product.api.fetch({source: this.getSource(), source_value: this.getSourceValue(), limit: this.limit})
    .then(response => Helper.injectExtraFieldsToResponse(response))
    .then(response => {
        this.productsData = response.data;
        this.isReady = true;
        salla.event.emit('salla-products-slider::products.fetched', response.data);
      });
    });
  }
  componentDidRender() {
    let processedCount = 0;
    const intervalId = setInterval(() => {
      this.host.querySelectorAll('[loading="lazy"]')?.forEach(img => img.removeAttribute('loading'));
      processedCount++;
      if (processedCount >= 10) {
        clearInterval(intervalId);
      }
    }, 1000);
  }

  private isSourceWithoutValue() {
    return ['offers', 'latest', 'sales', 'top-rated'].includes(this.getSource());
  }

  private getItemHTML(product) {

    //as a request they don't want to let the user to open the product details
    //todo:: find a better way to handle this request
    this.getSource() === 'landing-page' && (product.url = '');
    if (this.hasCustomComponent && this.productCardComponent.toLowerCase() == 'custom-salla-product-card') {
      return <div class="s-products-slider-card">
        <custom-salla-product-card product={product} source={this.getSource()} source-value={this.getSourceValue()} />
      </div>
    }

    if (this.hasCustomComponent) {
      const customElem = document.createElement(this.productCardComponent);
      customElem.setAttribute('product', JSON.stringify(product));
      customElem.setAttribute('source', this.getSource());
      customElem.setAttribute('source-value', this.getSourceValue());

      return <div class="s-products-slider-card" innerHTML={customElem.outerHTML} />;
    }

    return <div class="s-products-slider-card">
      <salla-product-card
        show-quantity={this.getSource() == 'landing-page'}
        hide-add-btn={this.getSource() == 'landing-page'}
        shadow-on-hover={true}
        product={product} />
    </div>;
  }

  private canRender() {
    return this.sourceValueIsValid && this.isReady;
  }

  private getSource() {
    return Helper.getProductsSource(this.source);
  }

  private getSourceValue() {
    return Helper.getProductsSourceValue(this.source, this.sourceValue);
  }

  render() {
    if (!this.canRender()) {
      return;
    }
    return (
      <Host class="s-products-slider-wrapper">
        <salla-slider
          class="s-products-slider-slider"
          id={this.sliderId || `s-products-slider-${Math.random().toString(36).substr(2, 9)}`}
          auto-play={this.autoplay}
          type="carousel"
          block-title={this.blockTitle}
          block-subTitle={this.subTitle}
          display-all-url={this.displayAllUrl}
          sliderConfig={this.sliderConfig ? this.sliderConfig : null}
        >
          <div slot="items">
            {this.productsData?.map(product => this.getItemHTML(product))}
          </div>
        </salla-slider>
      </Host>
    );
  }

}
